import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { AiFillCalendar, AiOutlineRise } from "react-icons/ai";
import { CgMenu, CgClose } from "react-icons/cg";
import Button from "../Button";
import { NAV, APP_URL, BRAND } from "../../data/site";

function Header() {
  const [open, setOpen] = useState(false);

  // Lock body scroll + close on Escape while the mobile drawer is open.
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <>
      <header className="header__wrapper">
        <div className="container mx-auto">
          <div className="flex items-center justify-between">
          <div className="flex items-center gap-12">
            <Link to="/" className="header__logo" aria-label={`${BRAND} home`}>
              <span className="brand-wordmark">{BRAND}</span>
            </Link>

            <nav aria-label="Primary" className="lg:block hidden">
              <ul className="flex items-center gap-6">
                {NAV.map((item) => (
                  <li key={item.path}>
                    <NavLink
                      to={item.path}
                      className={({ isActive }) =>
                        `header__link${isActive ? " is-active" : ""}`
                      }
                    >
                      {item.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          <div className="flex items-center gap-6">
            <p
              className="hidden lg:flex items-center gap-2 header__ticker"
              aria-label={`${BRAND} token price 3.735 TON, trending up`}
            >
              <AiFillCalendar aria-hidden="true" />
              <span aria-hidden="true">3.735</span>
              <AiOutlineRise className="text-green-500" aria-hidden="true" />
            </p>

            <span className="hidden lg:inline-flex">
              <Button to={APP_URL}>Enter App</Button>
            </span>

            <button
              type="button"
              className="lg:hidden header__menu-btn"
              aria-label={open ? "Close menu" : "Open menu"}
              aria-expanded={open}
              aria-controls="mobile-nav"
              onClick={() => setOpen((o) => !o)}
            >
              {open ? (
                <CgClose aria-hidden="true" />
              ) : (
                <CgMenu aria-hidden="true" />
              )}
            </button>
          </div>
          </div>
        </div>
      </header>

      {/* Drawer is a sibling of <header>: the header's backdrop-filter creates
          a containing block that would otherwise clip this fixed drawer. */}
      <div
        id="mobile-nav"
        className={`header__drawer${open ? " is-open" : ""}`}
        hidden={!open}
      >
        <nav aria-label="Mobile">
          <ul className="flex flex-col gap-2">
            {NAV.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `header__drawer-link${isActive ? " is-active" : ""}`
                  }
                  onClick={() => setOpen(false)}
                >
                  {item.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <Button
          to={APP_URL}
          className="btn--lg mt-6 w-full"
          onClick={() => setOpen(false)}
        >
          Enter App
        </Button>
      </div>
    </>
  );
}

export default Header;
